"use client";

// src/components/drawer/drawer.tsx
import { Drawer as VDrawer } from "vaul";
import {
  drawerBodyStyles,
  drawerContentStyles,
  drawerFooterStyles,
  drawerHeaderStyles,
  drawerTitleStyles
} from "./drawer.styles.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
function DrawerHeader({
  children,
  className
}) {
  const style = drawerHeaderStyles({ className });
  return /* @__PURE__ */ jsx("div", { className: style, children });
}
function DrawerBody({
  children,
  className
}) {
  const style = drawerBodyStyles({ className });
  return /* @__PURE__ */ jsx("div", { className: style, children });
}
function DrawerFooter({
  children,
  className,
  sticky = true
}) {
  const style = drawerFooterStyles({ className, sticky });
  return /* @__PURE__ */ jsx("div", { className: style, children });
}
function DrawerTitle({
  children,
  className
}) {
  const style = drawerTitleStyles({ className });
  return /* @__PURE__ */ jsx(VDrawer.Title, { className: style, children });
}
function DrawerClose({
  children,
  className,
  asChild = true
}) {
  return /* @__PURE__ */ jsx(VDrawer.Close, { className, asChild, children });
}
function DrawerContent({
  children,
  className,
  handleClassName
}) {
  const style = drawerContentStyles();
  return /* @__PURE__ */ jsxs(VDrawer.Portal, { children: [
    /* @__PURE__ */ jsx(VDrawer.Overlay, { className: "fixed inset-0 bg-neutral-90/40" }),
    /* @__PURE__ */ jsxs(VDrawer.Content, { className: style.content({ className }), children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          className: style.handle({ className: handleClassName }),
          "aria-hidden": true
        }
      ),
      children
    ] })
  ] });
}
function DrawerTrigger({
  children,
  className,
  asChild = true
}) {
  return /* @__PURE__ */ jsx(VDrawer.Trigger, { className, asChild, children });
}
function Drawer({
  children,
  ...rest
}) {
  return /* @__PURE__ */ jsx(VDrawer.Root, { ...rest, fixed: true, children });
}
export {
  Drawer,
  DrawerBody,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger
};
